import { useEffect } from 'react';

interface SEOHelmetProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
}

export default function SEOHelmet({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogUrl,
}: SEOHelmetProps) {
  useEffect(() => {
    const fullTitle = `${title} | 国产传媒`;
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }

    const ogTitleVal = ogTitle || title;
    const ogDescVal = ogDescription || description;
    const ogUrlVal = ogUrl || canonicalUrl || '';

    setMeta('og:title', ogTitleVal, true);
    setMeta('og:description', ogDescVal, true);
    setMeta('og:type', ogType, true);
    if (ogUrlVal) setMeta('og:url', ogUrlVal, true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', ogTitleVal);
    setMeta('twitter:description', ogDescVal);
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, ogUrl]);

  return null;
}